import { render, staticRenderFns } from "./DictonaryItem.vue?vue&type=template&id=7a84b44f&scoped=true&"
import script from "./DictonaryItem.vue?vue&type=script&lang=js&"
export * from "./DictonaryItem.vue?vue&type=script&lang=js&"
import style0 from "./DictonaryItem.vue?vue&type=style&index=0&id=7a84b44f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a84b44f",
  null
  
)

export default component.exports